export const TOKEN_URL = 'https://oauth.swinity.com/connect/token';
export function ROOT_URL() {
  return 'https://app.swinity.com/api';
}

export const APP_VERSION = "1.00.29";
export const LOGIN_SET_URL = "LOGIN_SET_URL";
export const USER_SET_WALLET = "USER_SET_WALLET";
export const FILTER_PAGESIZE = 24;


export const RESET_STATE = "RESET_STATE";
export const ACTION_SET_PAGETYPE = "ACTION_SET_PAGETYPE";
export const ACTION_FETCH_WEBSITESETTINGS = "FETCH_WEBSITESETTINGS";
export const ACTION_FETCH_WEBSITESETTINGS_PENDING = "FETCH_WEBSITESETTINGS_PENDING";
export const ACTION_FETCH_WEBSITESETTINGS_FULLFILLED = "FETCH_WEBSITESETTINGS_FULFILLED";
export const ACTION_FETCH_WEBSITESETTINGS_REJECTED = "FETCH_WEBSITESETTINGS_REJECTED";
export const ACTION_FETCH_PAGE_PENDING = "FETCH_PAGE_PENDING";
export const ACTION_FETCH_PAGE_FULLFILLED = "FETCH_PAGE_FULFILLED";
export const ACTION_FETCH_PAGE_REJECTED = "FETCH_PAGE_FULFILLED";

export const ACTION_SHOW_LOGIN = "SHOW_LOGIN";
export const ACTION_HIDE_LOGIN = "HIDE_LOGIN";
export const ACTION_FETCH_LOGIN_PENDING = "FETCH_LOGIN_PENDING";
export const ACTION_FETCH_LOGIN_FULFILLED = "FETCH_LOGIN_FULFILLED";
export const ACTION_FETCH_LOGIN_REJECTED = "FETCH_LOGIN_REJECTED";
export const ACTION_LOGIN_CLEARERROR = "ACTION_LOGIN_CLEARERROR";
export const LOGIN_STATUS_GUEST = "LOGIN_STATUS_GUEST";
export const LOGIN_STATUS_PENDING = "LOGIN_STATUS_PENDING";
export const LOGIN_STATUS_FAILED = "LOGIN_STATUS_FAILED";
export const LOGIN_STATUS_APPROVED = "LOGIN_STATUS_APPROVED";


export const SUPPORT_STATUS_NEW = "SUPPORT_STATUS_NEW";
export const SUPPORT_STATUS_PENDING = "SUPPORT_STATUS_PENDING";
export const SUPPORT_STATUS_SUCCESS = "SUPPORT_STATUS_SUCCESS";
export const SUPPORT_STATUS_FAILED = "SUPPORT_STATUS_FAILED";
export const ACTION_SUPPORT_SENDMESSAGE_PENDING = "ACTION_SUPPORT_SENDMESSAGE_PENDING";
export const ACTION_SUPPORT_SENDMESSAGE_FAILED = "ACTION_SUPPORT_SENDMESSAGE_FAILED";
export const ACTION_SUPPORT_SENDMESSAGE_FULFILLED = "ACTION_SUPPORT_SENDMESSAGE_SUCCESS";
export const ACTION_SUPPORT_GET_PENDING = "ACTION_SUPPORT_GET_PENDING";
export const ACTION_SUPPORT_GET_FAILED = "ACTION_SUPPORT_GET_FAILED";
export const ACTION_SUPPORT_GET_FULFILLED = "ACTION_SUPPORT_GET_FULLFILLED";


export const SIGNUP_SET_TYPE = "SIGNUP_SET_TYPE";
export const SIGNUP_STATUS_NEW = "SIGNUP_STATUS_NEW";
export const SIGNUP_STATUS_PENDING = "SIGNUP_STATUS_PENDING";
export const SIGNUP_STATUS_SUCCESS = "SIGNUP_STATUS_SUCCESS";
export const SIGNUP_STATUS_FAILED = "SIGNUP_STATUS_FAILED";
export const CONFIRM_STATUS_NEW = "CONFIRM_STATUS_NEW";
export const CONFIRM_STATUS_PENDING = "CONFIRM_STATUS_PENDING";
export const CONFIRM_STATUS_SUCCESS = "CONFIRM_STATUS_SUCCESS";
export const CONFIRM_STATUS_FAILED = "CONFIRM_STATUS_FAILED";
export const RESET_STATUS_NEW = "RESET_STATUS_NEW";
export const RESET_STATUS_PENDING = "RESET_STATUS_PENDING";
export const RESET_STATUS_SUCCESS = "RESET_STATUS_SUCCESS";
export const RESET_STATUS_FAILED = "RESET_STATUS_FAILED";
export const RESET_CONFIRM_STATUS_NEW = "RESET_CONFIRM_STATUS_NEW";
export const RESET_CONFIRM_STATUS_PENDING = "RESET_CONFIRM_STATUS_PENDING";
export const RESET_CONFIRM_STATUS_SUCCESS = "RESET_CONFIRM_STATUS_SUCCESS";
export const RESET_CONFIRM_STATUS_FAILED = "RESET_CONFIRM_STATUS_FAILED";

export const ALERT_WARNING_SUCCESS = "ALERT_WARNING_SUCCESS";
export const ALERT_WARNING_FAILED = "ALERT_WARNING_FAILED";
export const ALERT_WARNING_WARNING = "ALERT_WARNING_WARNING";
export const HIDE_WARNING = "HIDE_WARNING";
export const SHOW_WARNING = "SHOW_WARNING";



export const FETCH_SITEMAP_PENDING = "FETCH_SITEMAP_PENDING";
export const FETCH_SITEMAP_FULLFILLED = "FETCH_SITEMAP_FULFILLED";
export const FETCH_SITEMAP_REJECTED = "FETCH_SITEMAP_REJECTED";


//Actions For The Advertisement Data
export const FETCH_ADSURL_PENDING = "FETCH_ADSURL_PENDING";
export const FETCH_ADSURL_REJECTED = "FETCH_ADSURL_REJECTED";
export const FETCH_ADSURL_FULLFILLED = "FETCH_ADSURL_FULLFILLED";
export const FETCH_ADSPACKS_PENDING = "FETCH_ADSPACKS_PENDING";
export const FETCH_ADSPACKS_REJECTED = "FETCH_ADSPACKS_REJECTED";
export const FETCH_ADSPACKS_FULLFILLED = "FETCH_ADSPACKS_FULLFILLED";
export const FETCH_ADSSIZES_PENDING = "FETCH_ADSSIZES_PENDING";
export const FETCH_ADSSIZES_REJECTED = "FETCH_ADSSIZES_REJECTED";
export const FETCH_ADSSIZES_FULLFILLED = "FETCH_ADSSIZES_FULLFILLED";
export const FETCH_ADUPLOAD_PENDING = "FETCH_ADUPLOAD_PENDING";
export const FETCH_ADUPLOAD_REJECTED = "FETCH_ADUPLOAD_REJECTED";
export const FETCH_ADUPLOAD_FULLFILLED = "FETCH_ADUPLOAD_FULLFILLED";
export const FETCH_SSRADS_PENDING = "FETCH_SSRADS_PENDING";
export const FETCH_SSRADS_REJECTED = "FETCH_SSRADS_REJECTED";
export const FETCH_SSRADS_FULLFILLED = "FETCH_SSRADS_FULLFILLED";
export const FETCH_ADS_PENDING = "FETCH_ADS_PENDING";
export const FETCH_ADS_REJECTED = "FETCH_ADS_REJECTED";
export const FETCH_ADS_FULLFILLED = "FETCH_ADS_FULLFILLED";

//Actions For Working With Billers
export const FETCH_BILLING_PENDING = "FETCH_BILLING_PENDING";
export const FETCH_BILLING_FULLFILLED = "FETCH_BILLING_FULFILLED";
export const FETCH_BILLING_REJECTED = "FETCH_BILLING_REJECTED";
export const DEF_CHECKORDER_PENDING = "DEF_CHECKORDER_PENDING";
export const DEF_CHECKORDER_SUCCESS = "DEF_CHECKORDER_SUCCESS";
export const DEF_CHECKORDER_FAILED = "DEF_CHECKORDER_FAILED";
export const VXS_CREATEORDER_PENDING = "VXS_CREATEORDER_PENDING";
export const VXS_CREATEORDER_FULLFILLED = "VXS_CREATEORDER_FULFILLED";
export const VXS_CREATEORDER_REJECTED = "VXS_CREATEORDER_REJECTED";
export const VXS_CHECKORDER_PENDING = "VXS_CHECKORDER_PENDING";
export const VXS_CHECKORDER_FULLFILLED = "VXS_CHECKORDER_FULFILLED";
export const VXS_CHECKORDER_REJECTED = "VXS_CHECKORDER_REJECTED";

export const ACTION_LINKBANNERS_PENDING = "ACTION_LINKBANNERS_PENDING";
export const ACTION_LINKBANNERS_SUCCESS = "ACTION_LINKBANNERS_SUCCESS";
export const ACTION_LINKBANNERS_FAILURE = "ACTION_LINKBANNERS_FAILURE";


export const ACTION_REQUESTACCESS_PENDING = "ACTION_REQUESTACCESS_PENDING";
export const ACTION_REQUESTACCESS_FULFILLED = "ACTION_REQUESTACCESS_FULFILLED";
export const ACTION_REQUESTACCESS_REJECTED = "ACTION_REQUESTACCESS_REJECTED";

